'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetMarketsField } from '@morfi/backend-sdk-v2/client';
import { isMarketResolved } from '@morfi/contract-sdk';
import type { ReactNode } from 'react';
import { IdentityBeam } from '@/components/market/identity/identity-marks';
import { useFeatureGate } from '@/hooks/use-feature-gate';
import { MarketOutcomeHover } from './market-outcome-hover';
import { buildOutcomeRowSummaries } from './outcome-row-summary';

/** Keep live hover colors in a leaf so conviction updates preserve the card body. */
export function MarketFeedStackedCardBeam(t0) {
  const $ = _c(11);
  const {
    pubkey,
    children
  } = t0;
  const identityEnabled = useFeatureGate("creator_and_platform_markets") === true;
  const marketType = useGetMarketsField(pubkey, "marketType");
  const outcomes = useGetMarketsField(pubkey, "outcomes") ?? [];
  const status = useGetMarketsField(pubkey, "status");
  const convictionUpdatedAt = useGetMarketsField(pubkey, "convictionUpdatedAt");
  const outcomeCount = useGetMarketsField(pubkey, "outcomeCount");
  const winnerOutcomeIndex = useGetMarketsField(pubkey, "winnerOutcomeIndex");
  const summaries = buildOutcomeRowSummaries(outcomes, {
    status: status ?? undefined,
    convictionUpdatedAt,
    outcomeCount
  });
  if (identityEnabled && (marketType === "influencer" || marketType === "featured")) {
    let t1;
    if ($[0] !== children || $[1] !== marketType) {
      t1 = <IdentityBeam marketType={marketType} className="h-full">{children}</IdentityBeam>;
      $[0] = children;
      $[1] = marketType;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] !== status || $[4] !== winnerOutcomeIndex) {
    t1 = isMarketResolved(status ?? "") ? winnerOutcomeIndex ?? undefined : undefined;
    $[3] = status;
    $[4] = winnerOutcomeIndex;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== children || $[7] !== pubkey || $[8] !== summaries || $[9] !== t1) {
    t2 = <MarketOutcomeHover marketPubkey={pubkey} outcomes={summaries} winnerOriginalIndex={t1}>{children}</MarketOutcomeHover>;
    $[6] = children;
    $[7] = pubkey;
    $[8] = summaries;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}